import { getRecipientItemId } from '../EmailRecipientsField.utils'

export function getStyle(style, snapshot, isOpen) {
  if (!snapshot.isDragging) {
    return { maxWidth: '100%', overflow: isOpen ? 'hidden' : 'visible' }
  }

  return {
    ...style,
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '2px solid var(--button-bg)',
    borderRadius: '6px',
    display: 'flex',
    height: isOpen ? '28px' : '36px',
  }
}

export function getDraggableId(droppableIndex, item) {
  return `${droppableIndex}-${getRecipientItemId(item).toString()}`
}
